import {
    CREATE,
    DELETE,
    DELETE_MANY,
    GET_LIST,
    GET_MANY,
    GET_MANY_REFERENCE,
    GET_ONE,
    UPDATE,
    UPDATE_MANY,
} from "react-admin";


import {
    FirebaseDataProvider,
    FirebaseAuthProvider
} from "react-admin-firebase";
import firebase from 'firebase';
import { firebaseConfig } from '../FIREBASE_CONFIG';
const firebaseApp = firebase.apps[0];
const options = {
    logging: true,
    app: firebaseApp,
    persistence: 'local',
    dontAddIdFieldToDoc: true
};

const dataProvider = FirebaseDataProvider(firebaseConfig, options);

const resource='site';

class SitesStore {

    findById(id) {
        return dataProvider(GET_ONE, resource, {id: id});
    }

    findAll() {
       return dataProvider(GET_LIST, resource, {pagination: {page: 1, perPage: 99999}});
    }

}

export default SitesStore;

